export const walletSettingsMenuList = [
	{ name: 'Wallet', path: '/wallet-settings/wallet' },
	// { name: 'Settings', path: '/wallet-settings/settings' },
	// { name: 'Biodata', path: '/wallet-settings/biodata' },
];

export const settingsMenuList = [
	{ name: 'Profile & Setting', path: '/settings/profile' },
	{ name: 'Email & Password', path: '/settings/account' },
	{ name: 'Linked Account', path: '/settings/linked-accounts' },
	{ name: 'Login Key', path: '/settings/login-key' },
];

export const earnMenuList = [
	// { name: 'Swap Currency', path: '/earn/swap-currency' },
	{ name: 'Bridge', path: 'https://bridge-v2.creoplay.app/' },
	{ name: 'Staking', path: '/earn/staking' },
	// { name: 'CreoDeFi', path: 'https://defi.creoplay.app/' },
	// { name: 'Staking NFT', path: '/earn/staking-nft' },
	// { name: 'Launchpad', path: '/earn/launchpad' },
];

export const profileMenuList = [
	{ name: 'Overview', path: '/profile/overview' },
	{ name: 'Inventory', path: '/profile/inventory' },
	{ name: 'Deals', path: '/profile/deals' },
	{ name: 'Activity', path: '/profile/activity' },
	// { name: 'Sub-Account', path: '/profile/sub-account' },
];

export const buyCreoSourceList = [
	{
		name: 'pancakeswap',
		src: '/images/exchange/ex-pancakeswap.svg',
		path: 'https://pancakeswap.finance/swap?chain=bsc&inputCurrency=0x55d398326f99059fF775485246999027B3197955&outputCurrency=0x9521728bF66a867BC65A93Ece4a543D817871Eb7',
	},
	{
		name: 'mexc',
		src: '/images/exchange/ex-mexc.svg',
		path: 'https://www.mexc.com/exchange/CREO_USDT',
	},
	{
		name: 'bitmart',
		src: '/images/exchange/ex-bitmart.svg',
		path: 'https://www.bitmart.com/trade/en-US?symbol=CREO_USDT',
	},
	{
		name: 'coinstore',
		src: '/images/exchange/ex-coinstore.svg',
		path: 'https://www.coinstore.com/#/spot/CREOUSDT',
	},
	{
		name: 'tokocrypto',
		src: '/images/exchange/ex-tokocrypto.svg',
		path: 'https://www.tokocrypto.com/en/trade/CREO_USDT',
	},
	{
		name: 'kanga',
		src: '/images/exchange/ex-kanga.svg',
		path: 'https://trade.kanga.exchange/market/CREO-USDT',
	},
	{
		name: 'bitget',
		src: '/images/exchange/ex-bitget.svg',
		path: 'https://www.bitget.com/id/spot/CREOUSDT',
	},
	{
		name: 'uniswap',
		src: '/images/exchange/ex-uniswap.svg',
		path: 'https://app.uniswap.org/swap?chain=bnb&inputCurrency=0x55d398326f99059fF775485246999027B3197955&outputCurrency=0x9521728bF66a867BC65A93Ece4a543D817871Eb7',
	},
	{
		name: 'poloniex',
		src: '/images/exchange/ex-poloniex.svg',
		path: 'https://poloniex.com/trade/CREO_USDT',
	},
	{
		name: 'coinw',
		src: '/images/exchange/ex-coinw.svg',
		path: 'https://www.coinw.com/en_US/register?r=3031929',
	},
	{
		name: 'biconomy',
		src: '/images/exchange/ex-biconomy.svg',
		path: 'https://www.biconomy.com/exchange/CREO_USDT',
	},
	{
		name: 'btse',
		src: '/images/exchange/ex-btse.svg',
		path: 'https://www.btse.com/en/trading/CREO-USDT',
	},
];
